export default __webpack_public_path__ + "static/media/badge_mig_flare.f575db17.svg";